import { render, staticRenderFns } from "./AddBtn.vue?vue&type=template&id=0962d015&scoped=true&"
import script from "./AddBtn.vue?vue&type=script&lang=js&"
export * from "./AddBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddBtn.vue?vue&type=style&index=0&id=0962d015&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962d015",
  null
  
)

export default component.exports